import { render, staticRenderFns } from "./average-carbon-reduction-per-country.vue?vue&type=template&id=3c583c41&scoped=true&"
import script from "./average-carbon-reduction-per-country.vue?vue&type=script&lang=js&"
export * from "./average-carbon-reduction-per-country.vue?vue&type=script&lang=js&"
import style0 from "./average-carbon-reduction-per-country.vue?vue&type=style&index=0&id=3c583c41&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c583c41",
  null
  
)

export default component.exports